const axios = require('axios')
import { post, put, get } from 'axios'

const CONSOLIDATED = 'consolidate'
const URL = '/custom-surveys'

export const saveDraft = async customSurvey => post(`${URL}`, { customSurvey })

export const updateDraft = async customSurvey => {
  const { id } = customSurvey
  delete customSurvey.id
  return put(`${URL}/${id}`, { customSurvey })
}

export const searchCustomSurveys = async ({ offset, limit, status, title }) =>
  get(`${URL}?limit=${limit}&offset=${offset}&status=${status}&title=${title}`)

export const getCustomSurvey = async id => get(`${URL}/${id}`)

export const getSurvey = async id => get(`${URL}/${id}/survey`)
export const getUserCustomSurvey = getSurvey

export const postSurvey = async (id, body) => post(`${URL}/${id}/survey`, body)

export const getNpscores = async (customSurveyId, groupId = CONSOLIDATED) =>
  get(`${URL}/${customSurveyId}/groups/${groupId}/npscores`)

export const getReports = async (customSurveyId, groupId = CONSOLIDATED) =>
  get(`${URL}/${customSurveyId}/groups/${groupId}/reports`)

export const removeCustomSurvey = async id => axios.delete(`${URL}/${id}`)

export const closeCustomSurvey = async id => post(`${URL}/${id}/close`)

export const duplicateCustomSurvey = async id => post(`${URL}/${id}/duplicate`)

export const getSummary = async id => get(`${URL}/${id}/summary`)

export const getParticipation = async (
  customSurveyId,
  groupId = CONSOLIDATED
) => get(`${URL}/${customSurveyId}/groups/${groupId}/participation`)

export const getGroups = async customSurveyId =>
  get(`${URL}/${customSurveyId}/groups`)

export const getGroupsTree = async customSurveyId =>
  get(`${URL}/${customSurveyId}/groups/tree`)
